<template>
    <div name="payment-caution" class="contents">
        <h1>결제 유의사항 동의</h1>
        <h3>진료비 결제 유의사항</h3>
        - 건강보험이 적용되는 급여 진료의 진료비는 보험 공단 조회 시 자동으로 산정되며, 개인별로 보험 적용 범위에 따라 차이가 있습니다.<br>
        - 비급여 진료의 진료비는 병원의 내규와 처방 개월 수에 따라 달라질 수 있습니다.<br>
        - 요청하신 의약품이 정확하게 반영되었는지 확인한 후 결제를 진행해 주세요. 만약 요청하지 않은 의약품이 있는 경우 진료받은 병원에 먼저 문의해 주세요.<br>

        <h3>보습제 결제 및 배송 유의사항</h3>
        - 보습제 및 의약품 처방에 대한 결제 후 단순 변심과 보험약관 미확인 등으로 취소 및 변경이 불가합니다.<br>
        - 실비 청구가 가능한 보습제인 경우 보험 한도와 적용 여부가 보험사마다 다를 수 있으니 보험사에 확인한 후 결제해 주시기 바랍니다.<br>
        - 보습제 배송은 13시 이전까지 결제하시면 당일 출고되며 13시 이후 결제는 다음 영업일에 출고됩니다. 출고 후 보습제 도착까지 평균 1일 정도 소요되며 택배사 사정으로 늦어질 수 있습니다.<br>
        - 보습제 배송에 관한 송장번호는 보통 17~18시에 전달되며, 18시까지 받지 못하셨다면 솔닥 채널로 채팅 문의 부탁드립니다.<br>
        - 보습제 배송 송장번호를 받으셨다면 배송이 시작되어 배송 중인 상태입니다.<br>
        - 배송은 택배사에서 진행하므로 출발 이후의 자세한 배송 현황은 택배사에 문의해 주시기 바랍니다.

    </div>
</template>

<script>
export default {
    name: 'paymentCaution'
}
</script>

<style scoped>
.contents {
    padding: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/PaymentCaution.vue